eliminarDescuento = function(e){
    var data = e.dataset;
    $("#form_eliminar_descuento")[0].reset();
    $("#eliminar_descuento_id").val(data.id);
    $("#eliminar_descuento_nombre").html(`¿Deseas eliminar el descuento <strong>${data.nombre}</strong>?`);
}

tipoDescuento = function (e){
    let valor = null;
    if(e.value){
        valor = $('#'+e.id+' option:selected')[0].dataset.codigo==="porcentaje" ? '%' : '$';
        $("#span_tipo_descuento").html($("#span_tipo_descuento").html().replace('$',''));
        $("#span_tipo_descuento").html($("#span_tipo_descuento").html().replace('%',''));
        $("#span_tipo_descuento").html(valor);
        $("#cantidad_descuento").attr('placeholder',valor==="%"?'Porciento':'Pesos')
    }
}

if(document.getElementById('tipo_descuento_id')){
    $("#tipo_descuento_id").trigger('change');
}